import { ITaxonomyContent } from "../TaxonomyTags.types";

export const countAllDescendants = (
  tagId: string,
  categorizedData: { [key: string]: ITaxonomyContent[] },
): number => {
  let count = 0;

  for (const level in categorizedData) {
    const children = (categorizedData[level] || []).filter(
      (tag) => tag.parentId === tagId,
    );
    count += children.length;
    children.forEach((child) => {
      count += countAllDescendants(child.id, categorizedData);
    });
  }

  return count;
};
